// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__k6dyA","spin":"Spinner_spin__exvrK","fadeIn":"Spinner_fadeIn__1yhZ-"};